import { getIsWidgetsRestrictedDataSharingEnabled, getIsWidgetsRestrictedThirdPartyDataSharingEnabled, getIsWidgetsFirstPartyExperienceOptimizationEnabled, getIsWidgetsTaskbarAnnouncementsEnabled, getIsWidgetsTaskbarBadgesEnabled } from "../../externalApi/DMAPolicyEvaluatorApi";
export class DMAPolicyEvaluatorApi {
    async isWidgetsRestrictedDataSharingEnabled() {
        if (this._isWidgetsRestrictedDataSharingEnabled == undefined) {
            this._isWidgetsRestrictedDataSharingEnabled = await getIsWidgetsRestrictedDataSharingEnabled();
        }
        return this._isWidgetsRestrictedDataSharingEnabled;
    }
    async isWidgetsRestrictedThirdPartyDataSharingEnabled() {
        if (this._isWidgetsRestrictedThirdPartyDataSharingEnabled == undefined) {
            this._isWidgetsRestrictedThirdPartyDataSharingEnabled = await getIsWidgetsRestrictedThirdPartyDataSharingEnabled();
        }
        return this._isWidgetsRestrictedThirdPartyDataSharingEnabled;
    }
    async isWidgetsFirstPartyExperienceOptimizationEnabled() {
        if (this._isWidgetsFirstPartyExperienceOptimizationEnabled == undefined) {
            this._isWidgetsFirstPartyExperienceOptimizationEnabled = await getIsWidgetsFirstPartyExperienceOptimizationEnabled();
        }
        return this._isWidgetsFirstPartyExperienceOptimizationEnabled;
    }
    async isWidgetsTaskbarAnnouncementsEnabled() {
        if (this._isWidgetsTaskbarAnnouncementsEnabled == undefined) {
            this._isWidgetsTaskbarAnnouncementsEnabled = await getIsWidgetsTaskbarAnnouncementsEnabled();
        }
        return this._isWidgetsTaskbarAnnouncementsEnabled;
    }
    async isWidgetsTaskbarBadgesEnabled() {
        if (this._isWidgetsTaskbarBadgesEnabled == undefined) {
            this._isWidgetsTaskbarBadgesEnabled = await getIsWidgetsTaskbarBadgesEnabled();
        }
        return this._isWidgetsTaskbarBadgesEnabled;
    }
}
